.input {
  display: inline-flex;
  padding: 4px 6px !important;
  flex: 1;
  height: auto !important;

  border-radius: 4px;
  border: 1px solid var(--theme-primary-border, #e1e1e1);
  background: var(--theme-primary-background, #fff);
  margin: 0 !important;
}

.inplace {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.inplace:focus {
  background: rgba(255, 255, 255, 0.9) !important;
}
